<template>
    <h2 class="font-bold text-2xl mb-7 page-title h-7 flex items-center">{{ $__(translationKey) }}</h2>
</template>

<script>
    export default {
        props: ['translationKey']
    }
</script>
